import React, { useState } from "react";
import emailjs from "emailjs-com";

const Contact = () => {

    const [successMessage, setSuccessMessage] = useState("");

    const serviceId = "service_6jtqge9";
    const templateId = "template_ecvg0nk";
    const userId = "user_3CWde1rIFberqua2vt3R7";

 
        const sendEmail= (e) => {
            e.preventDefault();
        
            emailjs.sendForm(serviceId, templateId, e.target, userId)
              .then((result) => {
                  setSuccessMessage("Form sent successfully I will contact you ASAP");
                  console.log(result.text);
                 
              }, (error) => {
                  console.log(error.text);
              });

              e.target.reset();
            }

    return (
        <div id="contacts" className="contacts">
            <div className="text-center">
                <h1>Contact me</h1>
                <p>Please fill out the form and describe your project needs and I will contact you as soon as possible</p>

                <span className="success-message">{successMessage}</span>

                {/* <p>Sincere Request dont press button unnesserly</p> */}
            </div>
            <div className="container">
                <form onSubmit={sendEmail}>
                    <div className="row">
                        <div className="col-md-6 col-xs-12">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Name"
                                name="name"
                                
                            />
                            <div className="line"></div>
                        

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Phone Number"
                                name="phone"
                                
                            />
                            <div className="line"></div>
                           



                            <input
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                name="email"
                               
                            />
                            <div className="line"></div>
                          


                            <input
                                type="text"
                                className="form-control"
                                placeholder="Subject"
                                name="subject"
                             
                            />
                            <div className="line"></div>
                           

                        </div>
                        <div className="col-md-6 col-xs-12">
                            <textarea
                                type="text"
                                className="form-control"
                                placeholder="Description"
                                name="description"
                               
                            ></textarea>
                            <div className="line"></div>
                           

                            <button className="btn-main-offer contact-btn">Send</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Contact
